import {ChangeDetectionStrategy, Component, input} from "@angular/core"
import {MatCardModule} from "@angular/material/card"
import {Change, CHANGE_TYPES} from "../../CHANGELOG"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatCardModule],
    selector: "app-changelog",
    styleUrl: "./changelog.component.scss",
    templateUrl: "./changelog.component.html",
})
export class ChangelogComponent {
    readonly CHANGE_TYPES = CHANGE_TYPES
    readonly changes = input.required<readonly Change[]>()
}
